import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMasterRequest } from "../../services/wms";

const Editbranch = () => {
  const [request, setrequest] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getMasterRequest();

      if (result.status === "success") {
        setrequest(result.data.list);
      }
    };
    loadData();
  }, []);

  const handleonClick = (id) => {

    if (id === 1) {
    } else if (id === 2) {
    } else if (id === 3) {
    } else if (id === 4) {
    } else if (id === 5) {
    } else if (id === 6) {
    } else if (id === 7) {
    } else if (id === 8) {
    } else if (id === 9) {
    }
  };

  return (
    <div className="container-fluid  bg ">
      <div className="row m-4 d-flex justify-content-center ">
        {request &&
          request.length > 0 &&
          request.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-6 my-2 mt-4 items" key={index}>
              <Link className="text-decoration-none" to={item.linkto}>
                <div className="card1 shadow contact-bx item-content ">
                  <div className="card-body user-profile text-center ">
                      <i className={item.icon}  style={{ fontSize: "30px"}} />              
                    <div className="row">
                      <span
                        className="text-primary fw-bold user-name  mb-2"
                        style={{ fontSize: "25px", }}
                      >
                        {item.name}
                      </span>                 
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            
          ))}
      </div>     
    </div>
  );
};
export default Editbranch;
